var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"v-btn",class:_vm.classes,attrs:{"disabled":_vm.loading || _vm.disabled},on:{"click":_vm.onClick}},[_c('span',{staticClass:"v-btn__content"},[_vm._t("default")],2),(_vm.loading)?_c('div',{staticClass:"v-btn__loader"},[_c('v-loader-button')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }